import { render, staticRenderFns } from "./ViagemForm.vue?vue&type=template&id=122020b2&scoped=true"
import script from "./ViagemForm.vue?vue&type=script&lang=js"
export * from "./ViagemForm.vue?vue&type=script&lang=js"
import style0 from "./ViagemForm.vue?vue&type=style&index=0&id=122020b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122020b2",
  null
  
)

export default component.exports